import { IBearingResponse } from '@kcftech/prometheustypescriptapiclient';
import { DataSourceTable } from 'components/data_source_table/DataSourceTable';
import { TableColumn } from 'components/data_table/types';
import { BearingsPagedDataSource } from 'custom_hooks/data_hooks/data_source/bearingsDataSource';
import { useMemo } from 'react';
import { getId } from 'utils/data';

export type BearingsPropTable = Readonly<{
    dataSource: BearingsPagedDataSource;
}>;

export function BearingsTable({ dataSource }: BearingsPropTable) {
    const columns = useMemo<TableColumn<IBearingResponse>[]>(
        () => [
            {
                id: 'Manufacturer',
                header: () => 'Manufacturer',
                value: ({ rowData }) => rowData.Manufacturer,
                primary: true,
                locked: true,
                sortOn: 'Manufacturer',
            },
            {
                id: 'Name',
                header: () => 'Name',
                value: ({ rowData }) => rowData.Name,
                primary: true,
                locked: true,
                sortOn: 'Name',
            },
            {
                id: 'RollerCount',
                header: () => 'Number of Rollers',
                value: ({ rowData }) => rowData.RollerCount,
                sortOn: 'RollerCount',
            },
            {
                id: 'Ftf',
                header: () => 'FTF',
                value: ({ rowData }) => rowData.Ftf,
                sortOn: 'Ftf',
            },
            {
                id: 'Bsf',
                header: () => 'BSF',
                value: ({ rowData }) => rowData.Bsf,
                sortOn: 'Bsf',
            },
            {
                id: 'Bpfo',
                header: () => 'BPFO',
                value: ({ rowData }) => rowData.Bpfo,
                sortOn: 'Bpfo',
            },
            {
                id: 'Bpfi',
                header: () => 'BPFI',
                value: ({ rowData }) => rowData.Bpfi,
                sortOn: 'Bpfi',
            },
        ],
        []
    );

    return (
        <DataSourceTable
            dataSource={dataSource}
            rowKey={getId}
            columns={columns}
            noResultMessage="No bearings found."
        />
    );
}
